module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CONTENT"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Project")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.createNewProject
    }
  }, [_vm._v("NEW")]), _vm._v(" "), _c('span', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.loadStateFile
    }
  }, [_vm._m(0), _vm._v(" \n            LOAD FROM FILE\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileselector",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileSelected
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.saveStateFile
    }
  }, [_vm._m(1), _vm._v(" \n            SAVE TO FILE\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Project Name")]), _c('br'), _vm._v(" "), _c('table', {}, [_c('tr', [_c('td', {
    attrs: {
      "width": "80px"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', [(_vm.active_input !== 'projectname') ? _c('p', [_vm._v("\n                  " + _vm._s(_vm.projectName) + "\n                  "), (_vm.projectName === '') ? _c('span', {
    staticClass: "tag is-danger",
    on: {
      "click": function($event) {
        _vm.active_input = 'projectname'
      }
    }
  }, [_vm._v("NO PROJECT NAME")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.active_input === 'projectname') ? _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectName),
      expression: "projectName"
    }],
    staticClass: "input is-small",
    domProps: {
      "value": (_vm.projectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectName = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80px"
    }
  }, [(_vm.active_input !== 'projectname') ? _c('span', {
    staticClass: "button is-primary is-small pull-right",
    on: {
      "click": function($event) {
        _vm.active_input = 'projectname'
      }
    }
  }, [_vm._v(" edit")]) : _vm._e(), _vm._v(" "), (_vm.active_input === 'projectname') ? _c('span', {
    staticClass: "button is-primary is-small pull-right",
    on: {
      "click": function($event) {
        _vm.active_input = ''
      }
    }
  }, [_vm._v(" Update")]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._v("\n       Before uploading a file open it in gravit.io, press trim canvas, then export the image as SVG & use that SVG. This helps maximize compatibility with the HTML Engine.\n       "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "src": _vm.trim_instructions_image,
      "width": "200px"
    }
  }), _vm._v(" "), _c('FileLoader')], 1)]), _vm._v(" "), (_vm.uploadWarnings.length) ? _c('notification', {
    attrs: {
      "message": _vm.uploadWarnings[_vm.uploadWarnings.length - 1],
      "type": "warning",
      "direction": "'Up'"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box scrollx"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Assets")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.assetList), function(asset) {
    return _c('div', {
      staticClass: "column is-3"
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('p', {
      staticClass: "panel-heading"
    }, [_vm._v(_vm._s(asset.unique_name))]), _vm._v("\n            \n            " + _vm._s(_vm._f("hide")(_vm.numnodes = 0)) + "\n\n            "), _c('div', {
      staticClass: "panel-block"
    }, [(asset.nodes) ? _c('table', {
      staticClass: "table"
    }, [_vm._l((_vm.assetNodes(asset)), function(nodelist, nodetype) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(nodetype) + " nodes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(nodelist.length) + " " + _vm._s(_vm._f("hide")(_vm.numnodes += nodelist.length)))])])
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("All nodes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numnodes))])])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "footerAsset"
    }, [_c('span', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.removeAsset(asset)
        }
      }
    }, [_vm._m(2, true), _vm._v(" \n                REMOVE\n              ")])])])])
  })), _vm._v(" "), (Object.keys(_vm.assetList).length <= 0) ? _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "tag is-danger"
  }, [_vm._v("\n          No svg files have been loaded\n        ")])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd4da12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 63
// module chunks = 4